import {
  Directive,
  inject,
  input,
  DOCUMENT,
  createComponent,
  EnvironmentInjector,
  inputBinding,
  ApplicationRef,
  afterNextRender,
  runInInjectionContext,
  effect,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ClrDatagrid, ClrIcon } from '@clr/angular';
import { fromEvent } from 'rxjs';

/**
 * @example
 * <clr-datagrid deselectButton [(clrDgSelected)]="...">
 */
@Directive({
  selector: '[deselectButton][clrDgSelected][clrDgSelectionType]',
})
export class DeselectSingleSelectedDirective {
  private readonly grid = inject(ClrDatagrid);
  private readonly doc = inject(DOCUMENT);
  private readonly injector = inject(EnvironmentInjector);
  private readonly appRef = inject(ApplicationRef);

  readonly isEnabled = input.required<boolean>({ alias: 'deselectButton' });

  private readonly _btn: HTMLButtonElement;
  constructor() {
    this._btn = this.createButton();
    fromEvent(this._btn, 'click')
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.grid.selection.clearSelection());

    afterNextRender({
      mixedReadWrite: () => {
        runInInjectionContext(this.injector, () => {
          effect(() => {
            if (this.isEnabled()) this.appendButton();
          });
        });
      },
    });
  }

  private createButton(): HTMLButtonElement {
    const btn = this.doc.createElement('button') as HTMLButtonElement;
    const iconEl = this.doc.createElement('clr-icon');
    const ref = createComponent(ClrIcon, {
      environmentInjector: this.injector,
      hostElement: iconEl,
      bindings: [inputBinding('shape', () => 'times-circle'), inputBinding('size', () => '17')],
    });
    this.appRef.attachView(ref.hostView);
    btn.appendChild(iconEl);

    btn.setAttribute('class', 'btn btn-link btn-icon centred padding-11-lr noover');
    return btn;
  }

  private appendButton() {
    const container = this.grid.el.nativeElement.querySelector(
      '.datagrid-column.datagrid-select.datagrid-fixed-column'
    );
    container.classList.add('np');
    container.appendChild(this._btn);
  }
}
